module.exports = __webpack_public_path__ + "static/media/d9e4040d-32ff-4a1c-ac04-927a781da1f5.548dcaca.woff";